import '@chancenwerk/design/components/cr-button.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import '@chancenwerk/design/components/cr-icon.js';
import { html, type PropertyValueMap } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { toCanvas } from 'qrcode';

@customElement('campus-dialog-generate-qrcode')
export class CampusDialogGenerateQrcode extends ChromiumDialog<void> {
  static override get element_name() {
    return 'campus-dialog-generate-qrcode';
  }

  @property() public qrCodeString = '';

  override heading = 'QRCode zum Lerninhalt';

  protected override firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    toCanvas(this.shadowRoot?.getElementById('canvas'), this.qrCodeString, function (error) {
      if (error) console.error(error);
    });
    super.firstUpdated(_changedProperties);
  }

  override content() {
    return html`
      <cr-flex space="md" padding="md" vertical center crossaxis-center>
        <canvas id="canvas"></canvas>
        <cr-text> Speichern: Rechtsklick und danach 'Bild speichern unter'.</cr-text>
      </cr-flex>
    `;
  }
}
